import { pgTable, uuid, text, jsonb, timestamp } from 'drizzle-orm/pg-core'
import { sql } from 'drizzle-orm'

// Intentionally no FK on actor_id / entity_id — audit rows must survive user/entity deletion
export const auditLog = pgTable('audit_log', {
  id: uuid('id').primaryKey().default(sql`gen_random_uuid()`),
  tenantId: uuid('tenant_id'),
  actorId: uuid('actor_id'),
  actorType: text('actor_type', { enum: ['user', 'system', 'ai_agent'] }).notNull(),
  action: text('action').notNull(),
  entityType: text('entity_type'),
  entityId: uuid('entity_id'),
  payload: jsonb('payload'),
  createdAt: timestamp('created_at', { withTimezone: true }).notNull().default(sql`now()`),
})
